module.exports = __webpack_public_path__ + "img/queue.15818c8b.svg";